module.exports = __webpack_public_path__ + "static/graph-year-3_fr-1bd4f38ed2e87c28b5ef2c483fdfe90e.svg";